
export default {
	name: 'GoodsSimpleMessage',
	props: {
		message: {
			type: String
		}
	},
	computed: {
		messageArr() {
			if (!this.message) return []
			return this.message
				.split('-')
				.map(item => item.split('|'))
				.flat()
		}
	}
}
